// extracted by mini-css-extract-plugin
export default {"emptyData":"styles_emptyData__xbSaX","emptyBox":"styles_emptyBox__+qzJF","images":"styles_images__aElxK"};